<template>
    <v-container class="product">
        <demo-launch-pro :force="true" ref="launchpro"><template></template></demo-launch-pro>
        <div>
        <!-- Static QR codes -->
        <h1 class="smfm-page-title text-center mb-3">{{ $t('app.product.static.title') }}</h1>
        <div class="page-subtitle text-center secondary--text">
            {{ $t('app.product.static.subtitle') }}
        </div>
        <div class="d-flex justify-space-around align-stretch flex-wrap">
            <v-card flat tile class="product-block">
                <div class="img-wrap" :style="{'background-image': 'url(/images/product/static.svg)'}">
                </div>
                <v-card-title class="smfm-page-subheading px-0" v-html="$t('app.product.static.withfree')">
                </v-card-title>
                <v-card-text class="product-content pa-0">
                    <div v-for="(feature, index) in freefeatures" :key="index"
                        class="d-flex justify-start align-start mb-3">
                        <v-icon color="primary" class="me-4"> {{ iconCheck }}</v-icon>
                        <div :class="{'disable': feature.disable}">
                            {{ feature.description }}
                        </div>
                    </div>
                </v-card-text>
            </v-card>
            <v-card flat tile class="product-block">
                <div class="img-wrap" :style="{'background-image': 'url(/images/product/staticpro.svg)'}">
                </div>
                <v-card-title class="smfm-page-subheading px-0" v-html="$t('app.product.static.withpro')">
                </v-card-title>
                <v-card-text class="product-content pa-0">
                    <div v-for="(feature, index) in profeatures" :key="index"
                        class="d-flex justify-start align-start mb-3">
                        <v-icon color="primary" class="me-4"> {{ iconCheck }}</v-icon>
                        <div :class="{'disable': feature.disable}">
                            {{ feature.description }}
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </div>
        <!-- Dynamic QR codes -->
        <h1 class="smfm-page-title text-center mb-3" v-html="$t('app.product.dynamic.title')"></h1>
        <div class="page-subtitle text-center mb-5" v-html="$t('app.product.dynamic.subtitle')">
        </div>
        <div class="d-flex justify-center">
            <demo-launch-pro style="width: 100%;" class="text-center">
                <template slot-scope="{proceed}">
                    <v-btn large :block="$vuetify.breakpoint.xsOnly"
                        class="smfm-primary-btn mb-8" @click="proceed()">
                        {{ $t('app.product.gotopro') }}
                    </v-btn>
                </template>
            </demo-launch-pro>
        </div>
        <div class="d-flex justify-space-around align-center flex-wrap">
            <div class="img-wrap dynamic" :style="{'background-image': 'url(/images/product/dynamic.svg)'}">
            </div>
            <v-card flat tile class="product-block large">
                <v-card-title class="product-title px-0 mb-1">
                    <h2 style="max-width: 400px" v-html="$t('app.product.dynamic.featuresheader')"></h2>
                </v-card-title>
                <v-card-text class="product-content pa-0">
                    <div v-for="(feature, index) in mainfeatures" :key="index"
                        class="d-flex justify-start align-start mb-3">
                        <v-icon color="primary" class="me-4"> {{ iconCheck }}</v-icon>
                        <div :class="{'disable': feature.disable}">
                            {{ feature.description }}
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </div>
        <!-- URL redirection -->
        <div class="smfm-page-title text-center offer" v-html="$t('app.product.dynamic.typesheader')"></div>
        <div class="d-flex justify-space-around align-center flex-wrap offers">
            <div class="img-wrap dynamic order-last" :style="{'background-image': 'url(/images/product/url.svg)'}">
            </div>
            <div class="offer-block">
                <h2 class="offer-title" v-html="$t('app.product.dynamic.url.title')"></h2>
                <div class="offer-content" v-html="$t('app.product.dynamic.url.description')"></div>
                <v-btn large :block="$vuetify.breakpoint.xsOnly"
                       class="smfm-demo-exmp-btn mt-3" @click="openExampleDialog('url')">
                    {{$t('app.seeexample')}}
                </v-btn>
            </div>
        </div>
        <!-- Contact information -->
        <div class="d-flex justify-space-around align-center flex-wrap offers">
            <div class="img-wrap dynamic" :style="{'background-image': 'url(/images/product/contact.svg)'}">
            </div>
            <div class="offer-block">
                <h2 class="offer-title" v-html="$t('app.product.dynamic.contact.title')"></h2>
                <div class="offer-content" v-html="$t('app.product.dynamic.contact.description')"></div>
                <v-btn large :block="$vuetify.breakpoint.xsOnly"
                    class="smfm-demo-exmp-btn mt-3" @click="openExampleDialog('contact')">
                    {{$t('app.seeexample')}}
                </v-btn>
            </div>
        </div>
        <!-- Page with files -->
        <div class="d-flex justify-space-around align-center flex-wrap offers">
            <div class="img-wrap dynamic order-last" :style="{'background-image': 'url(/images/product/page.svg)'}">
            </div>
            <div class="offer-block">
                <h2 class="offer-title" v-html="$t('app.product.dynamic.page.title')"></h2>
                <div class="offer-content">
                    <div class="mb-3" v-html="$t('app.product.dynamic.page.description')"></div>
                    <div v-for="(feature, index) in pagewithfiles" :key="index"
                        class="d-flex justify-start align-start mb-3">
                        <v-icon color="primary" class="me-4"> {{ iconCheck }}</v-icon>
                        <div :class="{'disable': feature.disable}">
                            {{ feature.description }}
                        </div>
                    </div>
                </div>
                <v-btn large :block="$vuetify.breakpoint.xsOnly"
                    class="smfm-demo-exmp-btn mt-3" @click="openExampleDialog('page')">
                    {{$t('app.seeexample')}}
                </v-btn>
            </div>
        </div>
        </div>
        <about-dynamic-popup ref="exampledialog"></about-dynamic-popup>
    </v-container>
</template>

<script>
    import titleMixin from "@/mixins/titleMixin";
    import { mdiCheck } from '@mdi/js';
    import DemoLaunchPro from "@/components/demo/DemoLaunchPro";
    import AboutDynamicPopup from "@/components/about/AboutDynamicPopup";

    export default {
        name: "AboutProduct",
        components: { AboutDynamicPopup, DemoLaunchPro },
        mixins: [titleMixin],
        data() {
            return {
                freefeatures: [
                    { description: this.$t('app.product.static.freefeatures.generate'), disable: false },
                    { description: this.$t('app.product.static.freefeatures.styles', {no: 20}), disable: false },
                    { description: this.$t('app.product.static.freefeatures.logos', {no: 30}), disable: false },
                    { description: this.$t('app.product.static.freefeatures.templates'), disable: false },
                    { description: this.$t('app.product.static.freefeatures.colors'), disable: false },
                    { description: this.$t('app.product.static.freefeatures.download'), disable: false },
                ],
                profeatures: [
                    { description: this.$t('app.product.static.profeatures.logos'), disable: false },
                    { description: this.$t('app.product.static.profeatures.templates'), disable: false },
                    { description: this.$t('app.product.static.profeatures.presets'), disable: false },
                    { description: this.$t('app.product.static.profeatures.save'), disable: false },
                    { description: this.$t('app.product.static.profeatures.api'), disable: false },
                    { description: this.$t('app.product.static.profeatures.download'), disable: false },
                    { description: this.$t('app.product.static.profeatures.bulkdownload'), disable: false },
                ],
                mainfeatures: [
                    { description: this.$t('app.product.dynamic.features.dynamic'), disable: false },
                    { description: this.$t('app.product.dynamic.features.shorturl'), disable: false },
                    { description: this.$t('app.product.dynamic.features.statistics'), disable: false },
                    { description: this.$t('app.product.dynamic.features.api'), disable: false },
                    { description: this.$t('app.product.dynamic.features.domain'), disable: true },
                ],
                pagewithfiles: [
                    { description: this.$t('app.product.dynamic.page.examples.menu'), disable: false },
                    { description: this.$t('app.product.dynamic.page.examples.manual'), disable: false },
                    { description: this.$t('app.product.dynamic.page.examples.products'), disable: false },
                    { description: this.$t('app.product.dynamic.page.examples.albums'), disable: false },
                ]
            }

        },
        computed: {
            iconCheck() { return mdiCheck },
        },
        methods: {
            openExampleDialog(type) {
                this.$refs.exampledialog.showDialog(type)
            }
        },
        created() {
            this.setTitle(this.$t('app.product.metatitle'))
            this.setMetaDesc(this.$t('app.metadesc'))
            setTimeout(() => {
                if (this.$route.hash === '#pro') this.$refs.launchpro.proceed()
            }, 1500)
        }
    }
</script>

<style scoped lang="scss">
/*! purgecss start ignore */
.product {
    max-width: 1100px !important;
    .smfm-page-title {
        &.offer {
            font-size: 32px;
            line-height: 48px;
            max-width: 600px;
            @media(max-width: 960px) {
                font-size: 20px;
                line-height: 30px;
            }
        }
    }
    .page-subtitle {
        max-width: 600px;
        font-size: 20px;
        line-height: 30px;
        margin: 0 auto 90px;
        @media(max-width: 960px) {
            font-size: 16px;
            line-height: 24px;
            margin-bottom: 50px;
        }
    }
    .img-wrap {
        width: 100%;
        height: 300px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        &.dynamic {
            width: 398px;
        }
        @media(max-width: 960px) {
            height: 250px;
        }
    }
    .product-block {
        width: 500px;
        max-width: 500px;
        min-width: 320px;
        .smfm-page-subheading {
            margin: 44px 0 4px;
            @media(max-width: 960px) {
                margin: 34px 0 4px;
            }
            ::v-deep {
                span {
                    border-radius: 6px;
                    padding: 4px 14px;
                    margin: 0 5px;
                }
                .free {
                    background: #CCEFF0;
                }
                .pro-badge {
                    background: #00ADB5;
                    color: #fff;
                }
            }
        }
        .product-content {
            font-size: 16px;
            line-height: 24px;
            color: #393E46;
            .disable {
                color: #909295;
            }
        }
        &.large {
            .product-title, h2 {
                font-size: 30px;
                line-height: 42px;
                margin-top: 0;
                font-weight: 500;
                @media(max-width: 960px) {
                    font-size: 20px;
                    line-height: 30px;
                    margin-top: 34px;
                }
            }

        }
    }
    .offers {
        margin: 0 auto 100px;
        max-width: 940px;
        @media(max-width: 960px) {
            margin-bottom: 50px;
            .img-wrap {
                margin-bottom: 40px;
            }
        }
        .order-last {
            order: -1 !important;
            @media(min-width: 878px) {
                order: 1 !important;
            }
        }
        .offer-block {
            max-width: 440px;
            .offer-title, h2 {
                font-weight: normal;
                font-size: 30px;
                line-height: 42px;
                color: #21252C;
                margin-bottom: 10px;
                @media(max-width: 960px) {
                    font-size: 20px;
                    line-height: 30px;
                }
            }
            .offer-content {
                font-size: 16px;
                line-height: 24px;
                color: #393E46;
            }
        }
    }
}
/*! purgecss end ignore */
</style>
